import { Outlet, useParams } from 'react-router';
import styled from 'styled-components';

import { Container } from '@sorare/core/src/atoms/layout/Container';
import { Portal } from '@sorare/core/src/atoms/layout/Portal';
import { SecondaryPageBackground } from '@sorare/core/src/atoms/ui/SecondaryPageBackground';
import { PageHeader } from '@sorare/core/src/components/navigation/PageHeader';
import { navLabels } from '@sorare/core/src/lib/glossary';
import { laptopAndAbove } from '@sorare/core/src/style/mediaQuery';

import { LiveScoresButton } from '#src/components/arena/LiveScoresButton/index.tsx';
import { LineupsModeSwitcher } from '#src/components/boards/LineupsModeSwitcher/index.tsx';

const OVERLAY_MID_COLOR = '#757AEB';

const FullHeightContainer = styled(Container)`
  /* Must track the pinned mode switcher height; the portal renders it outside this subtree. */
  --lineups-bottom-bar-height: calc(var(--unit) * 5);
  @media ${laptopAndAbove} {
    --lineups-bottom-bar-height: calc(var(--unit) * 5 + var(--triple-unit));
    align-content: start;
    min-height: calc(
      var(--100vh) - var(--current-stack-height, 0px) - var(
          --lineups-bottom-bar-height
        )
    );
  }
`;

const ModeSwitcherWrapper = styled.div`
  padding-block-end: var(--double-unit);
  @media ${laptopAndAbove} {
    padding-block-end: var(--triple-unit);
  }
`;

const LineupsLayout = () => {
  const { fixture } = useParams();

  return (
    <>
      <PageHeader disableBackBrowser text={navLabels.lineups} />
      <Portal id="shell-background">
        <SecondaryPageBackground overlayMidColor={OVERLAY_MID_COLOR} />
      </Portal>
      <FullHeightContainer>
        <Portal id="above-bottom-bar-portal">
          <LiveScoresButton />
          <ModeSwitcherWrapper>
            <LineupsModeSwitcher fixture={fixture} />
          </ModeSwitcherWrapper>
        </Portal>
        <Outlet />
      </FullHeightContainer>
    </>
  );
};

export default LineupsLayout;
